<template>
  <div class="sticky header">
    <v-row no-gutters>
      <v-col 
        align-self="center"
        :cols="compactModeBreakpoint && $vuetify.breakpoint[`${compactModeBreakpoint}AndDown`] ? '8' : '4'"
        :class="{'d-flex': compactModeBreakpoint && $vuetify.breakpoint[`${compactModeBreakpoint}AndDown`]}"
      >
        <slot name="start">
          <v-btn
            icon
            class="align-self-center"
            @click="$emit('click:back', isDirty)"
          >
            <v-icon class="black--text">
              mdi-arrow-left
            </v-icon>
          </v-btn>
          <span 
            v-if="compactModeBreakpoint && $vuetify.breakpoint[`${compactModeBreakpoint}AndDown`]"
            class="d-block text-truncate align-self-center font-weight-bold"
          >
            {{ title }}
          </span>
        </slot>
      </v-col>
      <v-spacer v-if="$vuetify.breakpoint[`${compactModeBreakpoint}AndDown`]" />
      <v-col 
        v-else
        align-self="center"
        cols="2"
        lg="4"
        class="d-block text-center text-truncate font-weight-bold"
      >
        {{ title }}
      </v-col>
      <v-col
        v-if="!hideSave"
        align-self="center"
        cols="4"
        class="d-flex justify-end"
      >
        <slot name="lock-timer" />
        <!-- <lock-timer 
            :end-time="endTime"
            :on-accept="() => {$emit('on-accept')}"
            :renew-cb="(dialog) => {$emit('on-renew', dialog)}"
            small-mode-breakpoint="sm"
          /> -->
        <v-btn 
          v-if="$vuetify.breakpoint.mdAndUp"
          :class="[{'theme--dark': !isDirty}]"
          :color="isDirty ? 'green lighten-2' : this.$ftStyle.pageBarSaveButtonColor"
          @click="$emit('click:save')"
        >
          Save
        </v-btn>
        <v-btn
          v-else
          icon
          @click="$emit('click:save')"
        >
          <v-icon :class="{'black--text': isDirty}">
            mdi-content-save-outline
          </v-icon>
        </v-btn>
      </v-col>
      <v-spacer v-else />
    </v-row>
    <v-divider />
  </div>
</template>

<script>
export default {
  name: 'LeftSidePanelHeader',
  props: {
    title: String,
    endTime: [String, Number],
    hideSave: Boolean,
    isDirty: Boolean,
    compactModeBreakpoint: String, // Options: xs, sm, md, lg
  },
  data () {
    return {}
  },
}
</script>

<style scoped>
.sticky {
  position: sticky;
  top: 0px;
  z-index: 2;
}
.header {
  background-color: white;
}
</style>